<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="history"
      :search="search"
      :loading="isLoading"
      :sort-by="['sentAtDateTime']"
      sort-desc
      :footer-props="{
        itemsPerPageOptions: [30, 50, -1],
      }"
      no-data-text="You haven't sent any alerts yet."
      @click:row="onRowClick"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Alert History</v-toolbar-title>
          <v-row justify="end">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              placeholder="Search"
              append-icon="mdi-magnify"
              style="max-width: 200px;"
              class="pt-6"
            >
            </v-text-field>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.sentAtDateTime="{ item }">
        {{ formatDate(item.sentAtDateTime) }}
      </template>
      <template v-slot:item.deliveryPercent="{ item }">
        <PercentageChip :value="item.deliveryPercent"></PercentageChip>
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from '@/store/store'
// eslint-disable-next-line no-unused-vars
import moment from "moment";
import PercentageChip from '@/components/PercentageChip'
import Logger from '@/services/Logger'

export default {
  name: "History",
  components: {
    PercentageChip
  },
  data: () => ({
    search: "",
    isLoading: false,
    headers: [
      { text: "Date Sent", value: "sentAtDateTime" },
      { text: "Message", value: "message" },
      { text: "Sent By", value: "sentByUserFullName" },
      { text: "Recipients", value: "recipientCount" },
      { text: "Delivery %", value: "deliveryPercent" },
    ],
  }),
  computed: {
    ...mapState("messaging", ["history"]),
  },
  mounted() {
  },
  methods: {
    formatDate(dt) {
      return moment(dt).format("llll");
    },
    onRowClick(item) {
      this.$router.push({
        name: "HistoryDetails",
        params: { historyId: item.id },
      });
    },
    ...mapActions("messaging", ["loadHistory"]),
    ...mapActions("snackbar", ["showSnackbar"]),
  },
  beforeRouteEnter(to, from, next) {
    const loadDataPromise = new Promise((resolve, reject) => {
      store
        .dispatch("messaging/loadHistory")
        .then((history) => {
          resolve(history);
        })
        .catch((err) => {
          reject(err);
        });
    });

    next((vm) => {
      vm.isLoading = true;

      loadDataPromise
        .catch((err) => {
          Logger.error(err);
          store.dispatch("snackbar/showSnackbar", {
            message: err.message,
            color: "error",
          });
        })
        .finally(() => {
          vm.isLoading = false;
        });
    });
  }
};
</script>

<style lang="scss" scoped>
.v-data-table ::v-deep {
  .v-data-table__wrapper {
    table {
      tbody {
        tr {
          td {
            cursor: pointer !important;
          }
        }
      }
    }
  }
}
</style>
